interface UseCaseItem {
  tag: string;
  title: string;
  description: string;
}

interface UseCaseGridProps {
  items: UseCaseItem[];
}

export default function UseCaseGrid({ items }: UseCaseGridProps) {
  if (!Array.isArray(items) || items.length === 0) {
    throw new Error("UseCaseGrid: `items` array is empty or invalid.");
  }

  return (
    <div className="uc-grid">
      {items.map((item) => (
        <article className="uc" key={item.title}>
          <span className="uc-tag">{item.tag}</span>
          <h3>{item.title}</h3>
          <p>{item.description}</p>
        </article>
      ))}
    </div>
  );
}
